import script from "./FlatSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./FlatSpinner.vue?vue&type=script&setup=true&lang=js"

import "./FlatSpinner.vue?vue&type=style&index=0&id=4da36aa2&scoped=true&lang=scss"
script.__scopeId = "data-v-4da36aa2"

export default script